import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { saveActivityLevel } from '../../../store/ducks/user';
import SettingsContainer from '../../../components/settings-container';
import SingleSelect from '../../../components/single-select';

const selectOptions = [
  {
    optionText: 'Not active',
    subtext: 'I sit most of the day.',
    value: 'low'
  },
  {
    optionText: 'Lightly active',
    subtext: 'I stand most of the day.',
    value: 'moderate'
  },
  {
    optionText: 'Moderately active',
    subtext: 'I do some activity most of the day.',
    value: 'high'
  },
  {
    optionText: 'Heavily active',
    subtext: 'I do heavy labor most of the day.',
    value: 'very high'
  }
];

class DailyActivityPage extends Component {
  constructor(props) {
    super(props);

    this.state = { activityLevel: props.initialValue };
  }

  save = async () => {
    try {
      await this.props.saveActivityLevel(this.state.activityLevel);
    } catch (e) {
      /* do nothing */
    }
  }

  getActivityLevel = () => {
    return selectOptions.findIndex((el) => {
      return el.value === this.state.activityLevel;
    });
  }

  onSelect = (selectOption) => {
    const activityLevel = selectOption === null ? '' : selectOptions[selectOption].value;
    this.setState({ activityLevel });
  }

  render() {
    return (
      <SettingsContainer
        className="daily-activity-page"
        pageTitle="What's your activity level during the day?"
        save={ this.save }
        isValid={ Boolean(this.state.activityLevel) }
      >
        <SingleSelect
          selectOptions={ selectOptions }
          subtitle={ true }
          value={ this.getActivityLevel() }
          onSelect={ this.onSelect }
        />
      </SettingsContainer>
    );
  }
}

DailyActivityPage.propTypes = {
  initialValue: PropTypes.string,
  saveActivityLevel: PropTypes.func.isRequired
};

export default connect(
  state => ({
    initialValue: state.user.activity_level
  }),
  dispatch => ({
    saveActivityLevel: activityLevel => dispatch(saveActivityLevel(activityLevel))
  }),
  null,
  {
    withRef: true
  }
)(DailyActivityPage);
